import cn from 'classnames';
import React, {cloneElement, useCallback, useEffect, useRef, useState} from 'react';
import {Transition} from 'react-transition-group';

import s from './dialog.scss';

const duration = 200;

const defaultStyle = {
    opacity: 0,
    transition: `opacity ${duration}ms ease-in-out`
};

const transitionStyles = {
    entered: {opacity: 1}
};

const Dialog = ({
    autoCloseTime, noBg,
    closeAfterSubmit = true, rootNodeRemove, children,
    closeAfterAction, onAction,
    onClose: onOriginClose,
    onSubmit, ...rest
}) => {
    const [inProp, setInProp] = useState(true);
    const alreadyClose = useRef(false);

    const onClose = useCallback(() => {
        alreadyClose.current = true;
        if (onOriginClose) onOriginClose();
    }, []);

    if (window.__closeModalGroup) {
        window.__closeModalGroup.push(() => {
            setInProp(false);
        });
    } else { // 不要触发 onClose，因为这是一个关闭方法，仅仅用来关闭就好
        window.__closeModalGroup = [() => {
            setInProp(false);
        }];
    }

    useEffect(() => {
        if (autoCloseTime && autoCloseTime > 0) { // bug: 这里有bug，如果用户手动触发onClose，则这里会再次触发一次
            setTimeout(() => {
                if (alreadyClose.current) {
                    return;
                }
                setInProp(false);
                onClose();
            }, autoCloseTime);
        }
    }, []);

    return (
        <Transition
            appear
            unmountOnExit
            in={inProp}
            timeout={duration}
            onExited={rootNodeRemove}
        >
            {
                state => (
                    <div
                        className={cn(
                            s.container,
                            {
                                [s.noBg]: noBg
                            }
                        )}
                        style={{
                            ...defaultStyle,
                            ...transitionStyles[state]
                        }}
                    >
                        {
                            cloneElement(children, {
                                onSubmit: (data) => {
                                    if (closeAfterSubmit) {
                                        setInProp(false);
                                        onClose();
                                    }
                                    if (onSubmit) {
                                        onSubmit(data);
                                    }
                                },
                                onClose: onOriginClose ? () => {
                                    setInProp(false);
                                    onClose();
                                } : null,
                                onAction: onAction ? () => {
                                    if (closeAfterAction) {
                                        setInProp(false);
                                        onClose();
                                    }
                                    onAction({
                                        onClose: () => {
                                            setInProp(false);
                                        }
                                    });
                                } : null,
                                ...rest
                            })
                        }
                    </div>
                )
            }
        </Transition>
    );
};

export default Dialog;
